function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module utils/elementreplacer
 */

/**
 * Utility class allowing to hide existing HTML elements or replace them with given ones in a way that doesn't remove
 * the original elements from the DOM.
 */
var ElementReplacer = /*#__PURE__*/function () {
  function ElementReplacer() {
    _classCallCheck(this, ElementReplacer);

    /**
     * The elements replaced by {@link #replace} and their replacements.
     *
     * @private
     * @member {Array.<Object>}
     */
    this._replacedElements = [];
  }
  /**
   * Hides the `element` and, if specified, inserts the the given element next to it.
   *
   * The effect of this method can be reverted by {@link #restore}.
   *
   * @param {HTMLElement} element The element to replace.
   * @param {HTMLElement} [newElement] The replacement element. If not passed, then the `element` will just be hidden.
   */


  _createClass(ElementReplacer, [{
    key: "replace",
    value: function replace(element, newElement) {
      this._replacedElements.push({
        element: element,
        newElement: newElement
      });

      element.style.display = 'none';

      if (newElement) {
        element.parentNode.insertBefore(newElement, element.nextSibling);
      }
    }
    /**
     * Restores what {@link #replace} did.
     */

  }, {
    key: "restore",
    value: function restore() {
      this._replacedElements.forEach(function (_ref) {
        var element = _ref.element,
            newElement = _ref.newElement;
        element.style.display = '';

        if (newElement) {
          newElement.remove();
        }
      });

      this._replacedElements = [];
    }
  }]);

  return ElementReplacer;
}();

export { ElementReplacer as default };